import React from 'react';

import { EQuantityFormatKey } from '../../../StoreSettings.types';
import { ABBREVIATIONS_V2_TEXTS } from '../AbbreviationsSettingsV2.consts';
import {
  QuantityFieldPath,
  QuantityFieldValue
} from '../AbbreviationsSettingsV2.types';

import { QuantityFormatPanel } from './QuantityFormatPanel';
import { SectionHeading } from './SectionHeading';

interface IQuantityFormatSectionProps {
  sectionKey: EQuantityFormatKey;
  onCommit: (path: QuantityFieldPath, value: QuantityFieldValue) => void;
}

export const QuantityFormatSection = ({
  sectionKey,
  onCommit
}: IQuantityFormatSectionProps): React.ReactElement => (
  <div className="flex flex-col gap-5">
    <SectionHeading title={ABBREVIATIONS_V2_TEXTS.QUANTITY_SECTION_TITLE} />
    <QuantityFormatPanel sectionKey={sectionKey} onCommit={onCommit} />
  </div>
);
